import { BarChart3 } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";
import { TramsAccountSwitcher } from "@/components/trams/TramsAccountSwitcher";

export default function Reporting() {
  return (
    <div>
      <div className="px-6 pt-6">
        <TramsAccountSwitcher />
      </div>
      <PlaceholderPage 
        title="Reporting" 
        description="Access detailed analytics and reports to track your business performance and growth metrics."
        icon={<BarChart3 size={48} />} 
      />
    </div>
  );
}